import React, { useState, useEffect } from 'react'
import Dropdown1 from '../Dropdown1'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

export default function WeekdayDropdown({ className, selectedWeekdayValue, handleWeekdayChange, isDisabled }) {
  const { t } = useTranslation()
  const [selectedWeekDay, setSelectedWeekDay] = useState({
    value: -1,
    label: t('global.select')
  })
  const [weekdays] = useState([
    {
      value: -1,
      label: t('global.select')
    },
    {
      value: 1,
      label: t('weekdays.full.monday')
    },
    {
      value: 2,
      label: t('weekdays.full.tuesday')
    },
    {
      value: 3,
      label: t('weekdays.full.wednesday')
    },
    {
      value: 4,
      label: t('weekdays.full.thursday')
    },
    {
      value: 5,
      label: t('weekdays.full.friday')
    },
    {
      value: 6,
      label: t('weekdays.full.saturday')
    },
    {
      value: 0,
      label: t('weekdays.full.sunday')
    }
  ])

  const handleChange = (option) => {
    handleWeekdayChange(option)
  }

  useEffect(() => {
    if (selectedWeekdayValue > -1) {
      const week = weekdays.find((w) => w.value == selectedWeekdayValue)
      setSelectedWeekDay(week)
    }
  }, [selectedWeekdayValue])

  return (
    <Dropdown1
      isDisabled={isDisabled}
      className={`${styles.container} ${className}`}
      options={weekdays}
      value={selectedWeekDay}
      onChange={handleChange}
    />
  )
}
